import { render, staticRenderFns } from "./shareOrder1.vue?vue&type=template&id=945f1ac4&scoped=true&"
import script from "./shareOrder1.vue?vue&type=script&lang=js&"
export * from "./shareOrder1.vue?vue&type=script&lang=js&"
import style0 from "./shareOrder1.vue?vue&type=style&index=0&id=945f1ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945f1ac4",
  null
  
)

export default component.exports